import React, { useState } from "react";
import { Avatar, Button, Col, Divider, Form, Row, Upload } from "antd";
import { AiOutlineUser } from "react-icons/ai";
import { FaRegClock } from "react-icons/fa";
import TextArea from "antd/es/input/TextArea";
import { UploadOutlined } from "@ant-design/icons";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

const OwnerReqNonRenewal = ({ itemId, listId,checkedItems }) => {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    setIsDisabled(true)
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="list-container">
      <div className="evaluate-move-out">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <h3>
              If only one tenant is moving out we will not refund the Security
              Deposit until all tenants have vacated
            </h3>
          </Col>
          <Col span={24}>
            <h3>
              If this non renewal is for a section 8 tenant you MUST send a copy
              of it to section 8 so they are aware as well. There contact info
              can be founds on the process and procedure page.
            </h3>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <h3 className="green-info-text  green-heading">
                  Send this email to the tenant in appfolio put the property
                  address in the subject line
                </h3>
              </Col>
              <Col span={24}>
                <p className="green-info-text">
                  You have been issued a non renewal notice for your unit.
                  Please make sure and follow the steps below before you vacate
                  the unit.
                </p>
              </Col>
              <Col span={24}>
                <p className="green-info-text">
                  Your lease/rental agreement requires that you leave your
                  residence in clean and undamaged condition. We have every
                  intention of returning your entire security deposit as long as
                  you have fulfilled your agreement with us.
                </p>
              </Col>
              <Col span={24}>
                <Row className="green-info-text" gutter={[0, 16]}>
                  <Col span={24}>
                    <strong>Specifically, you should:</strong>
                    <ul>
                      <li>
                        <p>
                          Cooperate with the showing of the residence for sale
                          or rental, keeping it in presentable condition
                        </p>
                      </li>
                      <li>
                        <p>Turn off all automatic rental payments.</p>
                      </li>
                      <li>
                        <p>
                          Keep all utilities active in your name until the day
                          of your move out/key turn in.
                        </p>
                      </li>
                      <li>
                        <p>
                          Begin to discard all unwanted items for trash or
                          special pick-up—avoid piles of debris in front of your
                          residence on moving day
                        </p>
                      </li>
                      <li>
                        <p>
                          Remove all food, debris and other personal belongings
                        </p>
                      </li>
                      <li>
                        <p>Clean (and defrost if necessary) refrigerator</p>
                      </li>
                      <li>
                        <p>Clean stove, oven and any other appliances</p>
                      </li>
                      <li>
                        <p>Clean all floors and/or carpeting</p>
                      </li>
                      <li>
                        <p>Clean walls and touch up paint as needed.</p>
                      </li>
                      <li>
                        <p>Clean interior of the home.</p>
                      </li>
                      <li>
                        <p>
                          Spackle any nail holes over the size of a 5 penny
                          nail.
                        </p>
                      </li>
                      <li>
                        <p>
                          Be sure grounds and lawn are trim, clean and free of
                          weeds and leaves and all bushes and small "scrub"
                          trees are trimmed or removed.
                        </p>
                      </li>
                      <li>
                        <p>Report any and all damage in writing</p>
                      </li>
                      <li>
                        <p>
                          Upon leaving, please be sure to fully secure the
                          rental by locking all windows and doors
                        </p>
                      </li>
                      <li>
                        <p>
                          After you have vacated the residence, it will be
                          inspected for compliance with your lease/rental
                          agreement.
                        </p>
                      </li>
                      <li>
                        <p>
                          Costs for cleaning or repairing damage beyond normal
                          wear and tear, if any, will be charged against your
                          security deposit. You will be provided with an
                          itemized list of any charges incurred.
                        </p>
                      </li>
                    </ul>
                  </Col>
                  <Col span={24}>
                    <strong>
                      The following is a set of action items that we will need
                      for your move out.
                    </strong>
                    <ul>
                      <li>
                        <p>Dropping Off Your Keys</p>
                      </li>
                      <li>
                        <p>Prorated Rent</p>
                      </li>
                      <li>
                        <p>Carpet cleaning (If applicable)</p>
                      </li>
                      <li>
                        <p>Forwarding Address</p>
                      </li>
                    </ul>
                  </Col>
                  <Col span={24}>
                    <strong>Dropping Off Your Keys</strong>
                    <p>
                      Drop off your keys on the date of your move out at our
                      office: 1800 Canyon Park Circle #202 Edmond, OK 73013.
                      Bring the keys in an envelope clearly marked with the
                      property address. If there is a garage door opener, it can
                      be left on the kitchen counter. If no one answers the
                      door, you can slide the envelope through the secure mail
                      slot to the right of the front door. If the keys are left
                      in the mail slot, text 405-283-6521 to let us know you
                      have dropped the keys off, including your name, property
                      address.
                    </p>
                  </Col>
                  <Col span={24}>
                    <strong>Removing items</strong>
                    <p>
                      Be aware that any and all items left in the house will be
                      disposed of promptly. If there is anything of value or
                      that you wish to keep you must remove it prior to turning
                      in the keys. By turning in the keys you are acknowledging
                      that you have finished vacating the house and we are given
                      your permission to dispose of anything left in the home.
                      Tenants are not permitted back on the property after
                      vacating the property at move out.
                    </p>
                  </Col>
                  <Col span={24}>
                    <strong>Carpet Cleaning</strong>
                    <p>
                      Be aware that any and all items left in the house will be
                      disposed of promptly. If there is anything of value or
                      that you wish to keep you must remove it prior to turning
                      in the keys. By turning in the keys you are acknowledging
                      that you have finished vacating the house and we are given
                      your permission to dispose of anything left in the home.
                      Tenants are not permitted back on the property after
                      vacating the property at move out.
                    </p>
                  </Col>
                  <Col span={24}>
                    <p>JMSI Carpet Cleaning</p>
                  </Col>
                  <Col span={24}>
                    <p>Zerorez - (405) 606-7030</p>
                  </Col>
                  <Col span={24}>
                    <strong>Prorated Rent</strong>
                    <p>
                      You are responsible for rent until the final day of your
                      30 day notice. Please take your total rent, divide it by
                      30 and then multiply by the number of days of the month
                      until the final day of your 30 day notice. This will be
                      the total rent you owe.
                    </p>
                  </Col>
                  <Col span={24}>
                    <strong>Pre Move out Inspection</strong>
                    <p>
                      Please use the link in this email to do your self move out
                      inspection. Please complete that and share it with us
                      asap. Make sure and document all aspects of the property
                      for your records. If you complete it quickly we may be
                      able to review it and point out items for you to address
                      prior to vacating to get more of your Security Deposit
                      back.
                    </p>
                  </Col>
                  <Col span={24}>
                    <strong>Forwarding Address</strong>
                    <p>
                      Please respond with your forwarding address so that we can
                      send your security deposit information after we have
                      inspected the property if you have not turned it in
                      already. The amount of deposit returned to you is
                      contingent on the condition of the property upon your move
                      out. If you are enrolled in a security deposit waiver
                      program you will not be eligible for a refund. We have 45
                      days from the date of move out to inspect the property and
                      make a determination regarding the security deposit if one
                      was paid.
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" onClick={handleComplete} disabled={isDisabled}>
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={2}>
            <Avatar>KA</Avatar>
          </Col>
          <Col span={22}>
            <TextArea
              style={{
                height: 200,
                resize: "none",
              }}
              placeholder="Write a comment… Type @ to mention other users."
            />
          </Col>
        </Row>
        <Row justify="end" gutter={16}>
          <Col>
            <Upload>
              <Button style={{ marginTop: "10px" }}>
                <UploadOutlined />
              </Button>
            </Upload>
          </Col>
          <Col>
            <Button style={{ marginTop: "10px" }}>Send</Button>
          </Col>{" "}
        </Row>
      </div>
    </div>
  );
};

export default OwnerReqNonRenewal;
